import React from "react";

import "./BudgetAlertCard.css";

export interface BudgetAlertCardProps {
  name: string;
  advertiser: string;
  spent: number;
  budget: number;
  pct: number;
}

const fmt = (v: number) => "₹" + v.toLocaleString("en-IN");

export const BudgetAlertCard: React.FC<BudgetAlertCardProps> = ({ name, advertiser, spent, budget, pct }) => {
  const isExhausted = pct >= 100;

  return (
    <div className="ads-budget-card">
      <div className="ads-budget-card__top-row">
        <div className="ads-budget-card__name-col">
          <span className="ads-budget-card__name">{name}</span>
          <span className="ads-budget-card__advertiser">{advertiser}</span>
        </div>
        <span className={`ads-budget-card__pill ${isExhausted ? "ads-budget-card__pill--exhausted" : "ads-budget-card__pill--warning"}`}>
          {pct}% used
        </span>
      </div>

      <div className="ads-budget-card__progress-track">
        <div className="ads-budget-card__progress-fill" style={{ width: `${Math.min(pct, 100)}%` }} />
      </div>

      <div className="ads-budget-card__amounts-row">
        <span>{fmt(spent)} Spent</span>
        <span>{fmt(budget)} Budget</span>
      </div>

      {isExhausted && (
        <div className="ads-budget-card__warning">⚠️ Campaign budget exhausted</div>
      )}
    </div>
  );
};
